import { createSelector } from "reselect";
import { LocationLocale } from "../types/LocationLocale";
import { getActiveLocation } from "./getLocationPermissions";

export const getLocationLocale = createSelector(getActiveLocation, (location) =>
    location ? new LocationLocale(location.locale, location.currency) : new LocationLocale("en-au", "AUD")
);

export const getLocationCurrency = createSelector(getLocationLocale, (location) => location?.currency || "AUD");
